<div class="abp-page-container">
  <!-- Main page header -->
  <div class="flex">
    <div class="header-parent-title">
      <div class="header-child-title">Apple Management</div>
      <div class="header-child-title">.</div>
    </div>
  </div>

  <!-- Tab menu-->
  <!-- <p-tabMenu class="tabs-menu" [model]="tabItems" [activeItem]="activeItem">
    <ng-template pTemplate="item" let-item let-i="index">
      <div class="tabs-style">{{ item.label }}</div>
    </ng-template>
  </p-tabMenu> -->
  <rs-page-tabs [tabItems]="tabItems" (tabSelected)="activeItem = $event"> </rs-page-tabs>

  <!-- Photo Tab -->
  <!-- <div class="abp-photo" *ngIf="activeItem.label == abpTabs.PHOTO">
    <app-abp-tab-photo></app-abp-tab-photo>
  </div> -->

  <!-- Post Tab -->
  <div class="abp-post" *ngIf="activeItem.label == abpTabs.SHOWCASE">
    <app-abp-post></app-abp-post>
  </div>

  <!-- Q&A Tab -->
  <!-- <div class="abp-qa" *ngIf="activeItem.label == abpTabs.QA">
    <app-abp-tab-qa></app-abp-tab-qa>
  </div> -->
</div>
